import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getCreditOptionList } from "./Services";




export const useGetCreditOtions= (data:any) => {
  return useQuery(
    [endpoints.getCreditOptionList,data],
    () => getCreditOptionList(data),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};
